import React, {Fragment} from 'react';
import {Route, Routes} from 'react-router-dom';
import Landing from './pages/landing';
import './style.scss';
import {ReactNotifications} from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import NotFound from './pages/404';
import Index from './pages';
import AdminIndex from './pages/admin/index';
function App() {
  return (
    <Fragment>
      <ReactNotifications />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/admin/*" element={<AdminIndex />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/landing/:id" element={<Landing />} />
      </Routes>
    </Fragment>
  );
}
export default App;
